import React from "react";

import Alternate from "./Alternate";
import Social from "./Social";

const DEFAULT_SITE_TITLES = {
  en: "Spikex | AI Crypto Trading & Copy Trading Platform",
  "zh-CN": "Spikex | AI 加密货币交易 & 跟单交易平台",
  "zh-HK": "Spikex | AI 加密貨幣交易 & 跟單交易平台",
  pt: "Spikex | Negociação de criptomoedas com IA e copy trading",
  ar: "Spikex | تداول العملات المشفرة بالذكاء الاصطناعي ونسخ الصفقات",
  vi: "Spikex | Nền tảng giao dịch crypto AI & copy trading",
  es: "Spikex | Trading de criptomonedas con IA y copy trading",
  ja: "Spikex | AI暗号資産取引＆コピートレードプラットフォーム",
  ko: "Spikex | AI 암호화폐 거래 & 카피 트레이딩 플랫폼",
  ru: "Spikex | AI-торговля криптовалютой и копитрейдинг",
  tr: "Spikex | AI Kripto Para Ticareti ve Kopya Ticaret Platformu",
  hi: "Spikex | AI क्रिप्टो ट्रेडिंग और कॉपी ट्रेडिंग प्लेटफ़ॉर्म",
  in: "Spikex | Platform Trading Crypto AI & Copy Trading",
  th: "Spikex | แพลตฟอร์มเทรดคริปโตด้วย AI และ Copy Trading",
};

export default function SEO({ tdk = {}, tenant, category="home", isFuture=false, lang="en", resolvedUrl, Head=React.Fragment, domain="www"}) {

  /** CMS 未返回 describe 时，按当前语言填充 meta description / og:description / twitter:description */
  const defaultDescription = {
    "zh-CN":
      "Spikex 是面向加密货币、外汇与大宗商品的 AI 驱动交易平台，支持期货与跟单交易，安全、全球化服务。",
    "en":
      "Spikex is an AI-powered crypto, forex, and commodities trading platform with Futures, smart tools, and copy trading—built for secure, global execution.",
    "es": "Spikex - El Primer Exchange Social del Mundo",
    "hi": "Spikex-दुनिया का पहला सामाजिक संचार एक्सचेंज",
    "zh-HK":
      "Spikex 是面向加密貨幣、外匯與大宗商品的 AI 驅動交易平台，支援期貨與跟單交易，安全、全球化服務。",
    "in": "Spikex - Platform Bursa Bersosialisasi Pertama di Dunia",
    "pt":
      "A Spikex é uma plataforma de negociação com IA para criptomoedas, forex e commodities, com Futuros, ferramentas inteligentes e copy trading—segura e global.",
    "ar":
      "سبيكس منصة تداول مدعومة بالذكاء الاصطناعي للعملات المشفرة والفوركس والسلع، مع العقود الآجلة والأدوات الذكية ونسخ الصفقات—آمنة وعالمية.",
    "ja": "Spikex-世界初のソーシャルネットワーク型取引プラットフォーム",
    "ko": "Spikex - 세계 최초의 소셜 거래소",
    "ru": "Spikex - первая в мире криптовалютная биржа на базе сообщества",
    "th": "The World's First Social Infused Exchange",
    "tr": "Spikex - Dünyanın İlk Topluluk Odaklı Kripto Para Borsası",
    "vi":
      "Spikex là nền tảng giao dịch AI cho crypto, forex và hàng hóa, với Futures, công cụ thông minh và copy trading—an toàn, phục vụ toàn cầu."
  }
  const rawTitle = typeof tdk.title === "string" ? tdk.title.trim() : "";
  const resolvedTitle =
    !rawTitle || rawTitle === "Spikex"
      ? (DEFAULT_SITE_TITLES[lang] || DEFAULT_SITE_TITLES.en)
      : rawTitle;

  const rawDescribe =
    typeof tdk.describe === "string" ? tdk.describe.trim() : "";
  const resolvedDescription =
    rawDescribe || defaultDescription[lang] || defaultDescription["en"];

  var tdkInfo = {
    title : resolvedTitle,
    description : resolvedDescription,
    keywords : tdk.keyword || ["Spikex"]
  }

  return (
    <Head>
      <title>{tdkInfo.title}</title>
      <meta name="description" content={tdkInfo.description} />
      <meta name="keywords" content={tdkInfo.keywords.join(",")} />
      <meta
        name="viewport"
        content="minimal-ui,width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
      />
      {resolvedUrl != null && resolvedUrl !== "" ? (
        <Alternate lang={lang} resolvedUrl={resolvedUrl} domain={domain} />
      ) : null}
      <Social
        tdk={tdkInfo}
        tenant={tenant}
        lang={lang}
        category={category}
        isFuture={isFuture}
        resolvedUrl={resolvedUrl}
        domain={domain}
      />
    </Head>
  );
}
